import styled from 'styled-components';
import {
  mq,
  borderShape,
  getSpace,
  getGridSpan,
  px2rem,
  getColor
} from '../../../stylesheets/tools';

const StyledSliderControls = styled.div`
  width: ${getGridSpan(10, 'spread')};
  display: flex;
  position: absolute;
  top: 240px;
  margin-top: 30px;

  ${mq('xs')} {
    width: ${getGridSpan(8, 'spread')};
  }

  ${mq('m')} {
    position: relative;
    top: auto;
    width: ${getGridSpan(6)};
  }

  .sliderControls__wrapper {
    width: 100%;
    ${borderShape('black')}
    z-index: 999;
  }

  .sliderControls__button {
    appearance: none;
    border: none;
    margin: 0;
    background: transparent;
    cursor: pointer;
    padding: 15px;

    svg {
      width: ${px2rem('25px')};
      height: ${px2rem('25px')};

      ${mq('s')} {
        width: ${px2rem('28px')};
        height: ${px2rem('28px')};
      }
    }

    ${mq('m')} {
      padding: ${getSpace('s')};
    }

    &[disabled] svg {
      opacity: 0.2;
    }

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }
  }

  .sliderControls__prevButton {
    ${mq('s')} {
      border-right: 2px solid #000;
    }
  }

  .sliderControls__fullscreenButton {
    width: ${getGridSpan(6)};
    float: right;
    border-left: 2px solid #000;

    ${mq('s')} {
      width: auto;
    }
  }
`;

const StyledSliderControlsSkeleton = styled.div`
  width: ${getGridSpan(10, 'spread')};
  height: 60px;
  background: ${getColor('lightGray')};
  animation: opacityLoading 1.5s linear infinite alternate;
  margin-top: -5px;
  ${borderShape('#ececec')}

  ${mq('xs')} {
    width: ${getGridSpan(8, 'spread')};
  }

  ${mq('m')} {
    height: 88px;
    width: ${getGridSpan(6)};
  }
`;

export { StyledSliderControls, StyledSliderControlsSkeleton };
